import React, { Component } from "react";
import api from "../../Environment";
import renderHTML from "react-render-html";
import { t } from "react-multi-lang";

/**
 * CMS static page — /page/:id
 *
 * Must reload when the :id route param changes. React Router keeps this
 * component mounted across footer navigations (About → Privacy, etc.), so
 * relying only on componentDidMount leaves stale content until a full refresh.
 */
class Page extends Component {
  state = {
    data: {},
    loading: true,
  };

  componentDidMount() {
    this.loadPage(this.props.match.params.id);
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.match && prevProps.match.params
      ? prevProps.match.params.id
      : null;
    const nextId = this.props.match && this.props.match.params
      ? this.props.match.params.id
      : null;

    if (prevId !== nextId) {
      this.loadPage(nextId);
    }
  }

  loadPage = (uniqueId) => {
    if (!uniqueId) {
      this.setState({ loading: false, data: {} });
      return;
    }

    this.setState({ loading: true });

    api
      .getMethod("pages/list?unique_id=" + encodeURIComponent(uniqueId))
      .then((response) => {
        // Ignore stale responses if the user already navigated to another page.
        const currentId =
          this.props.match && this.props.match.params
            ? this.props.match.params.id
            : null;
        if (currentId !== uniqueId) {
          return;
        }

        if (response.data && response.data.success === true) {
          this.setState({
            loading: false,
            data: response.data.data || {},
          });
        } else {
          this.setState({ loading: false, data: {} });
        }
      })
      .catch(() => {
        const currentId =
          this.props.match && this.props.match.params
            ? this.props.match.params.id
            : null;
        if (currentId !== uniqueId) {
          return;
        }
        this.setState({ loading: false, data: {} });
      });
  };

  render() {
    const { loading, data } = this.state;

    return (
      <div className="top-bottom-spacing">
        <div className="">
          <div className="static-head">
            <h1>{loading ? t("loading") : data.title}</h1>
          </div>
          <div className="static-content">
            {loading ? t("loading") : data.description ? renderHTML(data.description) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default Page;
